var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from "react";
import styles from "../../styles/ChatbotBox.module.css";
import Box from "../Box";
import Button from "../Button";
import Card from "../Card";
import MessageBubble from "./MessageBubble";
var ChatbotBox = function (props) {
    var handleSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (props.text !== "") {
                props.onSend();
            }
            return [2 /*return*/];
        });
    }); };
    var textareaRef = useRef(null);
    useEffect(function () {
        if (!props.disabled && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [props.disabled]);
    var lastMessageRef = useRef(null);
    var oldMessagesLength = useRef(props.messages.length);
    useEffect(function () {
        if (oldMessagesLength.current !== props.messages.length &&
            lastMessageRef.current) {
            oldMessagesLength.current = props.messages.length;
            lastMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [props.messages, lastMessageRef.current]);
    var messageElements = useMemo(function () {
        var messages = __spreadArray([], props.messages, true).reverse();
        return messages.map(function (message, messageIndex) {
            var realMessageIndex = messages.length -
                messageIndex -
                2 -
                messages.filter(function (m) { var _a; return ((_a = m === null || m === void 0 ? void 0 : m.action) === null || _a === void 0 ? void 0 : _a.type) === "error"; }).length;
            return (_jsx(MessageBubble, { id: message.id || undefined, ref: messageIndex === 0 ? lastMessageRef : undefined, message: message, onGoodFeedback: function () {
                    return props.onGoodFeedback(realMessageIndex, message.id || undefined);
                }, onBadFeedback: function () {
                    return props.onBadFeedback(realMessageIndex, message.id || undefined);
                }, onHumanHandoff: function () {
                    return message.action &&
                        props.onHumanHandoff(realMessageIndex, message.action);
                }, onContinue: function () {
                    var _a;
                    (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, onRemember: function () {
                    props.onRemember();
                }, onError: function () {
                    return message.action &&
                        message.action.type === "error" &&
                        props.onTryAgain(realMessageIndex, message.action);
                }, submitIpRequest: function (event) {
                    props.onSubmitIpRequest(event);
                }, uiLabels: props.uiLabels }, messages.length - messageIndex - 2));
        });
    }, [
        props.messages,
        props.onGoodFeedback,
        props.onBadFeedback,
        props.onHumanHandoff,
        props.onTryAgain,
        props.uiLabels,
    ]);
    return (_jsx(Box, { col: true, width: "100%", maxWidth: props.width, height: props.height, justifyContent: "flex-end", alignItems: "flex-end", children: _jsxs(Card, { title: props.uiLabels.title, emoji: props.emoji, onClose: props.onClose, onMinimize: props.onMinimize, children: [_jsxs("div", { className: styles.chatbotMessages, children: [props.error && (_jsx(Box, { row: true, width: "100%", children: _jsx("div", { className: styles.errorMessage, children: _jsxs("p", { children: [_jsx("strong", { children: "ERROR" }), " ", props.error] }) }) })), props.loading && (_jsx(Box, { row: true, width: "100%", children: _jsx("div", { className: styles.chatbotBubbleBot, children: _jsx("div", { className: styles.dotTypingContainer, "aria-label": "Loading", children: _jsx("div", { className: styles.dotTyping }) }) }) })), messageElements] }), _jsxs("div", { className: styles.chatbotInput, children: [_jsx("textarea", { ref: textareaRef, "aria-label": "Enter your message", placeholder: props.uiLabels.textAreaPlaceholder, onChange: function (e) {
                                props.onChange(e.target.value);
                            }, onKeyPress: function (e) {
                                if (!e.shiftKey &&
                                    e.key === "Enter" &&
                                    props.text !== "" &&
                                    !props.disabled) {
                                    e.preventDefault();
                                    props.onSend();
                                }
                            }, value: props.text }), _jsx(Button, { onClick: handleSend, disabled: props.disabled, ariaLabel: "Send Message", children: props.uiLabels.sendButtonLabel })] })] }) }));
};
export default ChatbotBox;
